import { useLocation } from 'react-router-dom';

// Keyed on the path so every navigation remounts the wrapper and replays the
// entrance animation (see .page-transition in App.css). Layout chrome such as
// the navbar or dashboard sidebar stays outside it and does not flicker.
export default function PageTransition({ children }) {
  const { pathname } = useLocation();
  return (
    <>
      <div key={`bar-${pathname}`} className="route-progress" aria-hidden="true" />
      <div key={pathname} className="page-transition">
        {children}
      </div>
    </>
  );
}
